import { useEffect, useMemo, useState } from 'react';
import { fetchJson } from '@atlassian/jira-fetch';
import { useCurrentUser } from '@atlassian/jira-platform-services-user-current';
import { useLicensedProducts } from '@atlassian/jira-tenant-context-controller';
import { setSessionStorageData, getSessionStorageData } from './utils';

export const fetchConfluenceAccessPermissions = async (): Promise<boolean | undefined> => {
	try {
		const response = await fetchJson('/wiki/rest/api/user/current?expand=operations');
		return response.operations && response.operations.length > 0;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		return false;
	}
};

export const useUserHasConfluenceAccess = () => {
	const { data: currentUser } = useCurrentUser();
	const storageKey = `jira-definition-user-has-confluence-access-${currentUser.user.accountId}`;
	const cachedData = useMemo(() => getSessionStorageData(storageKey), [storageKey]);
	const [hasAccess, setHasAccess] = useState(Boolean(cachedData));

	const licensedProducts = useLicensedProducts();
	const hasConfluence = !!licensedProducts.confluence;

	useEffect(() => {
		if (!hasConfluence) return;

		const getConfluenceAccessPermissions = async () => {
			const response = await fetchConfluenceAccessPermissions();
			setSessionStorageData(storageKey, response);
			setHasAccess(Boolean(response));
		};

		if (cachedData === undefined) {
			getConfluenceAccessPermissions();
		} else {
			setHasAccess(cachedData);
		}
	}, [hasConfluence, storageKey, cachedData]);
	return { hasAccess };
};
